"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thorchain = exports.Thornode = void 0;
const bignumber_js_1 = require("bignumber.js");
const ethers_1 = require("ethers");
const erc20ABI_1 = __importDefault(require("./erc20ABI"));
const midgard_1 = require("./generated/midgard");
exports.Thornode = __importStar(require("./generated/thornode"));
const precision = {
    BCH: 8,
    BTC: 8,
    LTC: 8,
    DOGE: 8,
    DASH: 8,
    DGB: 8,
    ETH: 18,
    BNB: 8,
    THOR: 8,
};
const isNetworkSupported = (network) => {
    return Object.keys(precision).includes(network);
};
class Thorchain {
    constructor(args) {
        var _a;
        const midgardConfig = new midgard_1.Configuration({
            basePath: args.midgardUrl,
            baseOptions: {
                timeout: (_a = args.timeout) !== null && _a !== void 0 ? _a : 10000,
            },
        });
        this.midgard = new midgard_1.DefaultApi(midgardConfig);
        this.provider = new ethers_1.ethers.providers.JsonRpcProvider(args.rpcUrl);
    }
    // NOTE: contract precision is static and can be saved to prevent the need to always look up on chain
    toNativePrecision(amount, network, contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isNetworkSupported(network)) {
                throw new Error(`unsupported network when trying to convert to base precision: ${network}`);
            }
            let nativePrecision = precision[network];
            if (network === 'ETH' && contractAddress) {
                // contract address is all uppercase resulting in 0X prefix which ethers doesn't like
                // lower case contract address and call getAddress to verify and convert to checksum format
                const address = ethers_1.ethers.utils.getAddress(contractAddress.toLowerCase());
                const contract = new ethers_1.ethers.Contract(address, erc20ABI_1.default, this.provider);
                nativePrecision = yield contract.decimals();
            }
            return new bignumber_js_1.BigNumber(amount).times(new bignumber_js_1.BigNumber(10).pow(nativePrecision - precision.THOR)).toString(10);
        });
    }
    getTxDetails(txid, type) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { data, status, statusText } = yield this.midgard.getActions({
                limit: 1,
                offset: 0,
                txid: txid,
                type: type,
            });
            if (status !== 200) {
                throw new Error(`${txid} (${type}) - non 200 response: ${statusText}`);
            }
            if (data.count !== '1') {
                throw new Error(`${txid} (${type}) - expected actions: 1, received: ${data.count}`);
            }
            const action = data.actions[0];
            if (action.status !== 'success') {
                throw new Error(`${txid} (${type}) - unable to parse ${action.status} action`);
            }
            const outCoins = action.out[0].coins;
            const inCoins = action.in[0].coins;
            const feeCoins = (_b = (_a = action.metadata[type]) === null || _a === void 0 ? void 0 : _a.networkFees) !== null && _b !== void 0 ? _b : [];
            // aggregate coin values
            const [output, input, fee] = [outCoins, inCoins, feeCoins].map((coins) => (coins !== null && coins !== void 0 ? coins : []).reduce((prev, coin) => {
                const [network, assetString] = coin.asset.split('.');
                const [asset, contractAddress] = assetString.split('-');
                if (prev.network && prev.network !== network) {
                    throw new Error(`multiple networks found for ${type}: ${action}`);
                }
                if (prev.asset && prev.asset !== asset) {
                    throw new Error(`multiple assets found for ${type}: ${action}`);
                }
                const coinAmount = new bignumber_js_1.BigNumber(coin.amount);
                const amount = new bignumber_js_1.BigNumber(prev.amount).plus(coinAmount.isNaN() ? 0 : coinAmount).toString(10);
                return Object.assign(Object.assign({}, prev), { asset, network, contractAddress, amount });
            }, { amount: '0', asset: '', network: '' }));
            // convert amount to native precision
            output.amount = yield this.toNativePrecision(output.amount, output.network, output.contractAddress);
            input.amount = yield this.toNativePrecision(input.amount, input.network, input.contractAddress);
            fee.amount = yield this.toNativePrecision(fee.amount, fee.network, fee.contractAddress);
            const liquidityFee = (_c = action.metadata.swap) === null || _c === void 0 ? void 0 : _c.liquidityFee;
            return { output, input, fee, liquidityFee };
        });
    }
}
exports.Thorchain = Thorchain;
